<div class="Support-Flex">
  <pf-message-box
    *ngIf="hasCalendly"
    [mobileLayout]="true"
    messageType="success"
    class="mx-4"
    [customStyle]="{'border-radius': '5px', 'margin-bottom': '12px'}"
    [messageHtml]="'support_boxes.demo_html' | transloco"
    [buttonText]="'support_boxes.btn_schedule_call' | transloco"
    (buttonClick)="openCalendlyLink()"
    buttonClass="pf-button green outline">
  </pf-message-box>
  <pf-message-box
    *ngIf="hasContactSupport"
    [mobileLayout]="true"
    messageType="info"
    class="mx-4"
    [customStyle]="{'border-radius': '5px', 'margin-bottom': '12px'}"
    [messageHtml]="'support_boxes.chat_html' | transloco"
    [buttonText]="'support_boxes.btn_live_chat' | transloco"
    (buttonClick)="contactSupport()"
    buttonClass="pf-button blue outline">
  </pf-message-box>
  <pf-message-box
    *ngIf="hasRequestFeature"
    [mobileLayout]="true"
    messageType="error"
    class="mx-4"
    [customStyle]="{'border-radius': '5px', 'margin-bottom': '12px'}"
    [messageText]="'support_boxes.request_text' | transloco"
    [buttonText]="'support_boxes.btn_request_feature' | transloco"
    (buttonClick)="requestFeature()">
  </pf-message-box>
</div>
<div [innerHtml]="calendlyScript"></div>
